var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-prompt-confirmation',{attrs:{"show":_vm.show,"loading":_vm.loading,"input-props":_vm.inputProps,"title":_vm.title,"success-button-name":_vm.$t('Save')},on:{"submit":_vm.submit,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }